/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InscriptionFichierDto
 */
export interface InscriptionFichierDto {
    /**
     * 
     * @type {number}
     * @memberof InscriptionFichierDto
     */
    idinscriptionFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof InscriptionFichierDto
     */
    idinscription?: number;
    /**
     * 
     * @type {number}
     * @memberof InscriptionFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {string}
     * @memberof InscriptionFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the InscriptionFichierDto interface.
 */
export function instanceOfInscriptionFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionFichierDtoFromJSON(json: any): InscriptionFichierDto {
    return InscriptionFichierDtoFromJSONTyped(json, false);
}

export function InscriptionFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idinscriptionFichier': !exists(json, 'idinscriptionFichier') ? undefined : json['idinscriptionFichier'],
        'idinscription': !exists(json, 'idinscription') ? undefined : json['idinscription'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function InscriptionFichierDtoToJSON(value?: InscriptionFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idinscriptionFichier': value.idinscriptionFichier,
        'idinscription': value.idinscription,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
    };
}

